<template>
  <div>
    <div class="dashboard__topbar">
      <KeywordFilter></KeywordFilter>
    </div>

    <div class="dashboard__widgets widget-container">
      <list-widget class="widget-container__widget"
          routeName="lastEdited"
          :items="lastEditeds.items"
          :totalCount="lastEditeds.total">
        <template slot="header">{{ $t('dashboard.last_edited') }}</template>
      </list-widget>

      <list-widget
          v-if="isSuperAdmin()"
          class="widget-container__widget"
          routeName="lastEditedGuests"
          :items="listProducts.slice(0, 10)">
        <template slot="header">{{ $t('dashboard.parkings') }}</template>
        <template slot="add-button">
          <a href="#" @click.prevent="openListModal()" class="link link--blue">{{ $t('common.show_all') }}
            <i class="icon icon--arrow"></i>
          </a>
        </template>
      </list-widget>

      <ValidatePermit class="widget-container__widget"></ValidatePermit>
    </div>
    <ListModal
      @cancel="closeListModal"
      @confirmed="confirmedListModal"
      v-if="showListModal"
      :isShowFooterButtons="false"
    >
      <template v-slot:default>
        <ul
          v-for="(product, key) in productsForList"
          :key="key"
          class="listOfGuestPackages"
        >
          <li
            class="listOfGuestPackages__item listOfGuestPackages__char"
          >
            {{ product.char }}
          </li>
          <li
            class="listOfGuestPackages__item"
          >
              <list-widget
                class="listOfGuestPackages__widget"
                routeName="lastEditedGuests"
                :items="product.items"
                :hideHeader="true"
                :hideFooter="true"
              >
              </list-widget>
          </li>
        </ul>
      </template>
    </ListModal>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import 'pusher-js';
import * as mTypes from 'store/mutation-types';
import ListWidget from 'common/ListWidget';
import ListModal from 'common/ListModal';
import Autocomplete from 'common/Autocomplete';
import Messages from 'common/Messages';
import ValidatePermit from 'common/ValidatePermit';
import KeywordFilter from './KeywordFilter';
import { connectEcho } from 'src/utils.js'

export default {
  components: {
    ListWidget,
    ListModal,
    Autocomplete,
    Messages,
    ValidatePermit,
    KeywordFilter,
  },
  computed: mapGetters({
    lastEditeds: 'landlord/lastEditeds/lastEditeds',
    lastEditedsGuest: 'landlord/lastEditedsGuest/lastEditedsGuest',
    user: 'user/user/user',
  }),
  created() {
    this.fetchLastEdited();
    this.fetchProducts();
  },
  destroyed() {
    connectEcho().leave(`private-user_${this.role}_${this.roleId}`);
  },
  mounted() {
    // this.user.data.selectedRole.isSuperadmin && this.user.data.selectedRole.isSuperadmin === true ? this.role = 'superAdmin' : this.role = `${this.user.data.selectedRole.role}s`;
    this.role = `${this.user.data.selectedRole.role}s`;
    this.roleId = this.user.data.selectedRole.id;
  },
  methods: {
    fetchLastEdited() {
      this.$store.commit(`landlord/lastEditeds/${mTypes.SET_LIMIT}`, this.limit.lastEditeds);
      this.$store.dispatch('landlord/lastEditeds/fetch', { user: this.user, limit: this.limit.lastEditeds, orderBy: 'updated_at' });
    },
    fetchProducts() {
      this.$store.dispatch('landlord/lastEditedsGuest/fetch', { user: this.user })
        .then(() => {
          this.listProducts = this.lastEditedsGuest.items;
          this.initProductsWebsocets();
        });
    },
    initProductsWebsocets() {
      connectEcho().private(`user_${this.role.toLowerCase()}_${this.roleId}`)
        .listen('.change.guest.pack.count', (e) => {
          this.listProducts = e.products.products;
        });

      // const pusher = new Pusher('123', {
      //   wsHost: 'localhost',
      //   wsPort: 6001,
      //   forceTLS: false,
      //   disableStats: true,
      //   // authEndpoint: 'http://localhost/laravel-websockets/auth',
      // });

      // const channelUser = pusher.subscribe(
      //   'private-product_418',
      // );

      // channelUser.bind('App\\Events\\Illuminate\\Events\\ChangeGuestPackCount', (data) => {
      //   console.log(data);
      // });
    },
    openListModal() {
      this.productsForList = {};
      this.showListModal = true;

      const obj = this.listProducts;
      for (let key in obj) {
        const char = obj[key].name.toUpperCase().charAt(0);
        if (char in this.productsForList) {
          this.productsForList[char].items.push(obj[key]);
        } else {
          this.productsForList[char] = {
            char: char,
            items: []
          };
          this.productsForList[char].items.push(obj[key]);
        }
      }
      this.productsForList = Object.values(this.productsForList).sort(function(a, b){
        let charA=String(a.char.toLowerCase()),
            charB=String(b.char.toLowerCase());

        return charA > charB ? 1 : -1;
      });
    },
    closeListModal() {
      this.showListModal = false;
    },
    confirmedListModal() {
      this.showListModal = false;
    },
  },

  data() {
    return {
      limit: {
        lastEditeds: 10,
        products: 10,
        requests: 5,
      },
      role: null,
      roleId: null,
      showListModal: false,
      productsForList: {},
      listProducts: [],
    };
  },
};
</script>


<style lang="scss" scoped>
@import '~styles/variables.scss';

  .dashboard {
    &__content {
      margin-top: 0;
    }
    &__mainview {
      background-color: inherit;
      background-color: inherit;
      padding: 0;
    }
  }

  .widget-container {
    margin: 20px 0 0 0;
    display: flex;
    flex: 1;
    align-content: stretch;
    justify-content: flex-start;
    transition: all 250ms ease-in-out;

    @media screen and (max-width: 700px) {
      flex-direction: column;
      transition: all 250ms ease-in-out;
    }

    @media screen and (max-width: 1115px) {
      flex-direction: column;
      transition: all 250ms ease-in-out;
    }

    &__widget {
      margin: 0 10px 10px 0;
      width: 300px;
      max-width: 600px;
      flex: 1 0 auto;
      transition: all 250ms ease-in-out;

      @media screen and (max-width: 1115px) {
        width: auto;
        transition: all 250ms ease-in-out;
        margin: 0 0 10px 0;
      }

    }
  }

  .listOfGuestPackages {
    position: relative;
    padding: 0;
    margin: 0;

    &:not(:last-child) {
      margin-bottom: 30px;
    }

    &__item {
      list-style-type: none;
    }

    &__char {
      position: sticky;
      top: 0;
      z-index: 200;
      padding: 5px;
      background-color: $grey-four;
      font-size: 20px;
      text-align: center;
    }

    &__widget {
      &:first-child {
        margin-top: 5px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/landlord-dashboard/MainView.vue